module.exports = __webpack_public_path__ + "img/item-2.8d7934e.png";